import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLargeVideoParticipant } from '../../../large-video/functions';
import { stopAiSpeaking } from '../../actions';
import { getDeepaiTheme } from '../../functions';
/**
 * Scoped root class positioned by the theme CSS as a floating rounded-square
 * icon button at the bottom center (between the menu and hangup FABs on mobile).
 */
const ROOT_CLASS = 'deepai-stop-ai';
/** Filled rounded-square "stop" glyph. */
const IconStop = (React.createElement("svg", { "aria-hidden": true, fill: 'currentColor', viewBox: '0 0 24 24' },
    React.createElement("rect", { height: 12, rx: 2, width: 12, x: 6, y: 6 })));
/**
 * A floating "stop the AI's speech" button shown below the AI tile while a
 * DeepAI theme is active and the AI is on the large video. It is always
 * clickable: if the AI is not currently speaking the stop command is simply a
 * no-op on the AI side, so there is no need to gate it on speaking state.
 * Clicking sends a stop command to the AI over the data channel (see
 * stopAiSpeaking / config.deepaiStopCommand).
 *
 * @returns {JSX.Element | null}
 */
export default function DeepaiStopAiButton() {
    const dispatch = useDispatch();
    const theme = useSelector(getDeepaiTheme);
    const largeVideoParticipant = useSelector(getLargeVideoParticipant);
    const onClick = useCallback(() => {
        dispatch(stopAiSpeaking());
    }, [dispatch]);
    // Only under a DeepAI theme, and only while the AI tile is on the stage.
    if (!theme || largeVideoParticipant?.deepaiRole !== 'ai') {
        return null;
    }
    return (React.createElement("button", { "aria-label": 'AI\u306E\u767A\u8A71\u3092\u6B62\u3081\u308B', className: ROOT_CLASS, onClick: onClick, title: 'AI\u306E\u767A\u8A71\u3092\u6B62\u3081\u308B', type: 'button' }, IconStop));
}
